import React from "react";
import styles from "./EmbeddedMap.module.scss";

const EmbeddedMap = () => {
  return (
    <section className={styles.mapContainer}>
      <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.5718488639873!2d78.3822981!3d17.451209299999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93002eebca4f%3A0xac64a3be605b98df!2sSealkloud%20Infotech%20Pvt%20limited!5e0!3m2!1sen!2sin!4v1699356667414!5m2!1sen!2sin"
        title="Sealkloud Infotech Pvt Ltd Location"
        loading="lazy"
        className={styles.mapIframe}
        allowFullScreen={true}
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </section>
  );
};

export default EmbeddedMap;
